import { chooseService, getLocalBounds } from '../utils';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { ApplicationState } from "../store";
import { APIState } from "../store/API/types";
import { BrowseState } from "../store/browse/types";

const {CONFIG} = window;


const useGetBrowseFrame = (pane: number, time: number | null, isThumbnail: boolean = false) => {
  const [source, setSource] = useState<null | string>(null);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {token, token2} = useSelector<ApplicationState, APIState>(state => state.API);

  const camId = browsePanes?.[pane]?.id;

  const inited = browsePanes?.[pane]?.inited;
  const success = browsePanes?.[pane]?.success;

  useEffect(() => {
    if (camId && inited && time && typeof success !== 'undefined') {
      const {width} = getLocalBounds(document.getElementById(`pane-${pane}`));
      const src = chooseService(
        () => `https://${CONFIG.ServerAddress}:${CONFIG.ServerPort}/session/get_thumbnail?token=${token}${token2 ? `&token2=${token2}` : ''}&id=${camId}&time=${Math.round(time)}`,
        () => {
          const id = browsePanes?.[pane]?.id;
          return `https://${CONFIG.ServerAddress}:${CONFIG.ServerPort}/SeeTecGatewayService/GatewayServiceRest/Request_Bare_Archive_JPEG?sessionID=${token}&cameraEntityID=${id}&imageWidth=${Math.round(width)}&timestamp=${Math.round(time)}`;
        }
      );
      setSource(src);
    }
    if (typeof success === 'undefined') {
      setSource(null);
    }
  }, [inited]);

  return source
};

export default useGetBrowseFrame;